<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <NeList ref="neCms" :neArr='netype' :select='neClick'></NeList>
    </template>
    <template v-slot:right_view>
      <div>
        <UsersTableMenu @methodEnum='methodEnum'></UsersTableMenu>
        <UsersTable ref="userstable"></UsersTable>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import UsersTable from '../../../../components/subscriberconfig/mcsSubscriber/user/UsersTable';
import UsersTableMenu from '../../../../components/subscriberconfig/mcsSubscriber/user/UsersTableMenu';
import BasicLayout from '../../../../layouts/BasicLayout';
import NeList from '../../../../components/common/NeList';

export default {
  name: 'UserMainPage',
  components: {
    NeList,
    UsersTable,
    UsersTableMenu,
    BasicLayout
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t('SubscriberIms.neList')
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: this.$t('SubscriberIms.menuTitleUserMcs')
      },
      netype: [12],
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'add':
          this.$refs.userstable.openAddUserPage();
          break;
        case 'mod':
          this.$refs.userstable.openModUserPage();
          break;
        case 'del':
          this.$refs.userstable.delUsers();
          break;
        case 'qryGroupList':
          this.$refs.userstable.openQryGroupListPage();
          break;
        case 'addBlackList':
          this.$refs.userstable.openAddBlackListPage();
          break;
        case 'qryBlackList':
          this.$refs.userstable.openQryBlackListPage();
          break;
        case 'export':
          this.$refs.userstable.exportData();
          break;
        case 'refresh':
          this.$refs.userstable.reFreshByNoCondition();
          break;
        case 'search':
          this.$refs.userstable.openSearchPage();
          break;
        default:
      }
    },
    neClick() {
      this.$refs.userstable.getGridData(this.$refs.neCms.getNe());
    }
  }
};
</script>

<style scoped>

</style>
